import { render, staticRenderFns } from "./CustomerHeader.vue?vue&type=template&id=a9555bc2&scoped=true&"
import script from "./CustomerHeader.vue?vue&type=script&lang=js&"
export * from "./CustomerHeader.vue?vue&type=script&lang=js&"
import style0 from "./CustomerHeader.vue?vue&type=style&index=0&id=a9555bc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9555bc2",
  null
  
)

export default component.exports